<template>
    <table class="table table-striped table-bordered">
        <thead>
        <tr>
            <th>Name</th>
            <th>Site name</th>
            <th>Backup type</th>
            <th>State</th>
            <th>Started at</th>
            <th>Finished at</th>
            <th>Services</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(backup, index) in backups" :key="index">
            <td>{{ backup.name }}</td>
            <td>{{ backup.siteName }}</td>
            <td>{{ backup.backupType }}</td>
            <td>{{ backup.state }}</td>
            <td>{{ formatDate(backup.startedAt) }}</td>
            <td>{{ formatDate(backup.finishedAt) }}</td>
            <td>
                <div v-for="(service, serviceIndex) in backup.services" :key="serviceIndex">
                    {{ service.service }} - {{ service.state }} ({{ formatDate(service.startedAt) }} - {{ formatDate(service.finishedAt) }})
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'BackupList',
    data() {
        return {
            localizedFormat: require('dayjs/plugin/localizedFormat')
        }
    },
    methods: {
        formatDate(dateString) {
            if (null === dateString) {
                return "..."
            }
            dayjs.extend(this.localizedFormat)
            return dayjs(dateString).format('L LTS')
        },
    },
    props: {
        backups: Array
    }
};
</script>

<style>
.badge {
    margin: 5px;
}
</style>
